.portraits {
    position: relative;
    display: flex;
    align-items: center;
    height: 45px;
}

.chat-with-us-container {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    min-width: 155px;
}

.active-now {
    background: var(--green);
    border-radius: 50%;
    display: inline-block;
    height: 8px;
    width: 8px;
}

@media screen and (max-width: 650px) {
    .have-questions {
        display: none;
    }
}
